import { render, staticRenderFns } from "./FeaturedUpload.vue?vue&type=template&id=274c046e&"
import script from "./FeaturedUpload.vue?vue&type=script&lang=js&"
export * from "./FeaturedUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports